import { render, staticRenderFns } from "./ProductsAddUpdate.vue?vue&type=template&id=0fa400a3&"
import script from "./ProductsAddUpdate.vue?vue&type=script&lang=js&"
export * from "./ProductsAddUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ProductsAddUpdate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports